import {
  SET_RESULT_DATA,
  SET_FONT_PREVIEW_INPUT_DATA,
  SET_FONT_PREVIEW_SLIDER_VALUE,
  RESULTS_ERROR,
  SET_RESULT_REQUEST_FLAG,
  SET_RESULTS_PAGE_NUMBER,
} from '../constants/actionTypes';

/**
 * Action that is dispatched when the result data needs to be updated.
 * @param  {Object} resultData The object of result data.
 * @return {Object}
 */
export function setResultData(resultData) {
  return {
    type: SET_RESULT_DATA,
    value: resultData,
  };
}

/**
 * Action that is dispatched when the font preview input data needs to be updated.
 * @param  {String} inputData The input value data.
 * @return {Object}
 */
export function setFontPreviewInputText(inputData) {
  return {
    type: SET_FONT_PREVIEW_INPUT_DATA,
    value: inputData,
  };
}

/**
 * Action that is dispatched when the font preview slider value needs to be updated.
 * @param  {String} sliderValue The slider value data.
 * @return {Object}
 */
export function setFontPreviewSliderValue(sliderValue) {
  return {
    type: SET_FONT_PREVIEW_SLIDER_VALUE,
    value: sliderValue,
  };
}

/**
 * Action that is dispatched when the error code needs to be updated.
 * @param  {String} errorCode The error code that the component will match and show.
 * @return {Object}
 */
export function setError(errorCode) {
  return {
    type: RESULTS_ERROR,
    errorCode,
  };
}

/**
 * Action that is dispatched when the is needed to change the value of the flag, to
 * allow/disallow new results requests.
 * @param  {Boolean} value The new value of the flag
 * @return {Object}
 */
export function setResultRequestFlag(value) {
  return {
    type: SET_RESULT_REQUEST_FLAG,
    value,
  };
}

/**
 * Action that is dispatched to store the page number shown on the Results List.
 * @param  {Boolean} value The new results page
 * @return {Object}
 */
export function setResultsPageNumber(value) {
  return {
    type: SET_RESULTS_PAGE_NUMBER,
    value,
  };
}



// WEBPACK FOOTER //
// ./src/actions/result.js